(function () {

    'use strict';

    angular.module('Services').factory('AccountingService', AccountingService);

    AccountingService.$inject = ['Request'];

    function AccountingService(Request) {
        let shipmentValidation = [];
        return {
            Invoices: {
                getAll: function (callback, errCallback, data) {
                    Request.get({
                        url: ApiURLs.accounting.invoices,
                        successCallback: callback,
                        errorCallback: errCallback,
                        data: data
                    });
                },
                downloadFile: function (successCallback, errorCallback, data) {
                    Request.downloadFile({
                        fileName: 'historical-billing-' + data.id + '.' + data.fileType.split('/')[1],
                        method: 'GET',
                        url: ApiURLs.accounting.customerBillingDownloadPDFCSV.replace(':customerBillId', data.id),
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        fileType: data.fileType,
                        responseType: 'arraybuffer',
                        headers: {
                            Accept: data.fileType
                        }
                    });
                },
                getOne: function (callback, errCallback, id) {
                    Request.get({
                        url: ApiURLs.accounting.invoices + '/' + id,
                        successCallback: callback,
                        errorCallback: errCallback
                    });
                },
                getReconciledShipment: function (invoiceId, callback, errCallback, data) {
                    const url = ApiURLs.accounting.unreconciledShipment.replace(':id', invoiceId);
                    Request.get({
                        url: url,
                        successCallback: callback,
                        errorCallback: errCallback,
                        data: data
                    });
                },
                historicalBillings: function (callback, errCallback, data) {
                    Request.get({
                        url: ApiURLs.accounting.customerBilling,
                        successCallback: callback,
                        errorCallback: errCallback,
                        data: data
                    });
                },
                getHistoricalBilling: function (callback, errCallback, id) {
                    Request.get({
                        url: ApiURLs.accounting.customerBillingDetails.replace(':customerBillId', id),
                        successCallback: callback,
                        errorCallback: errCallback
                    });
                },
                create: function (callback, errCallback, data) {
                    Request.post({
                        method: 'POST',
                        url: ApiURLs.accounting.invoices,
                        successCallback: callback,
                        errorCallback: errCallback
                    }, data);
                },
                update: function (callback, errCallback, id, data) {
                    Request.post({
                        url: ApiURLs.accounting.invoices + '/' + id,
                        successCallback: callback,
                        errorCallback: errCallback
                    }, data);
                },
                importShipments: function (successCallback, errorCallback, invoiceId) {
                    Request.post({
                        url: ApiURLs.accounting.importShipments.replace(':invoiceId', invoiceId),
                        method: 'PUT',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    });
                },
                udpateInvoiceShipment: function (successCallback, errorCallback, invoiceId, shipmentId, data) {
                    Request.post({
                        url: ApiURLs.accounting.updateInvoiceShipment.replace(':invoiceId', invoiceId).replace(':shipmentId', shipmentId),
                        method: 'PUT',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, data);
                },
                updateUnreconciledShipment: function (successCallback, errorCallback, shipmentId, data) {
                    Request.post({
                        url: ApiURLs.accounting.udpateUnreconciledShipment.replace(':shipmentId', shipmentId),
                        method: 'PUT',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, data);
                },
                approveUnreconciledShipments: function (successCallback, errorCallback, data) {
                    Request.post({
                        method: 'POST',
                        url: ApiURLs.accounting.approveUnreconciledShipments,
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, data);
                },
                convertSurchargesFieldToArray: function (suchargesField) {
                    const keys = Object.keys(suchargesField);
                    const mappedData = [];
                    for (let i = 0; i < keys.length; i++) {
                        mappedData.push({
                            'description': keys[i],
                            'value': suchargesField[keys[i]]
                        });
                    }
                    return mappedData;
                },
                reconcileByShipment: function (successCallback, errorCallback, invoiceId, shipmentIds) {
                    Request.post({
                        method: 'POST',
                        url: ApiURLs.accounting.reconcileByShipment.replace(':invoiceId', invoiceId),
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, shipmentIds);
                },
                unreconcileByShipmentForceApproved: function (successCallback, errorCallback, invoiceId, shipmentIds) {
                    Request.post({
                        method: 'POST',
                        url: ApiURLs.accounting.reconcileByShipment.replace(':invoiceId', invoiceId) + '?forceReconcile=true',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, shipmentIds);
                },
                downloadImportInvoiceTemplate: function (successCallback, errorCallback) {
                    Request.downloadFile({
                        method: 'GET',
                        url: ApiURLs.accounting.importInvoiceTemplate,
                        fileName: 'invoice-import-template.csv',
                        fileType: 'text/csv',
                        headers: {
                            'Content-type': 'text/csv',
                            'Accept': 'text/csv'
                        },
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        responseType: 'arraybuffer',
                    });
                },
                tagFutileShipment: function (futileShipmentId, successCallback, errCallback, payload) {
                    Request.post({
                        method: 'POST',
                        url: ApiURLs.shipment.tagFutileShipment.replace(':futileShipmentId', futileShipmentId),
                        successCallback: successCallback,
                        errorCallback: errCallback
                    }, payload);
                },
                exportAllInvoice: function (invoiceId, successCallback, errorCallback, reconcile) {
                    const url = ApiURLs.accounting.exportInvoiceShipment.replace(':id', invoiceId) + `?reconciled=${reconcile}`
                    Request.downloadFile({
                        method: 'GET',
                        url: url,
                        fileName: `invoice-${reconcile ? 'reconciled' : 'unreconciled'}-shipments-export.csv`,
                        fileType: 'text/csv',
                        headers: {
                            'Content-type': 'text/csv',
                            'Accept': 'text/csv'
                        },
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        responseType: 'arraybuffer',
                    });
                },
                approveAllUnreconciledShipments: function (invoiceId, successCallback, errorCallback) {
                    Request.post({
                        method: 'POST',
                        url: ApiURLs.accounting.approveAllUnreconciledShipments.replace(':id', invoiceId) + '?forceReconcile=true',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    });
                }

            },
            Reconciliations: {
                importCSV: function (invoiceId, successCallback, errorCallback, file, eventCallback) {
                    Request.upload({
                        url: `${ApiURLs.accounting.invoices}/${invoiceId}/import`,
                        method: 'POST',
                        successCallback: function (data) {
                            shipmentValidation = data;
                            successCallback(shipmentValidation);
                        },
                        errorCallback,
                        eventCallback
                    }, file);
                },
                getAll: function (callback) {
                    callback(shipmentValidation);
                },
                getOne: function (shipmentId) {
                    return shipmentValidation.find(data => data.shipment.id === shipmentId);
                },
                confirm: function (successCallback, errorCallback, id) {
                    if (!shipmentValidation || !shipmentValidation.length) {
                        errorCallback('No Shipments to confirm');
                    }
                    const payload = shipmentValidation.map(data => {
                        const tempShipment = {
                            id: data.shipment.id,
                            consignmentId: data.shipment.consignmentId,
                            invoiceDetails: angular.copy(data)
                        };
                        if (tempShipment.invoiceDetails.chargeableWeight) {
                            tempShipment.invoiceDetails.chargeableWeight = tempShipment.invoiceDetails.chargeableWeight.replace('kg', '') || 0;
                        }

                        delete tempShipment.invoiceDetails.shipment;
                        return tempShipment;
                    });
                    Request.post({
                        url: `${ApiURLs.accounting.invoices}/${id}/import/approve`,
                        method: 'PUT',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, payload);
                },
                clearShipments() {
                    shipmentValidation = [];
                },
                runReconcillation: function (successCallback, errorCallback, data) {
                    Request.post({
                        method: 'POST',
                        url: `${ApiURLs.accounting.invoices}/reconcile`,
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, data);
                }
            },
            Surcharges: {
                getAll: function (callback, errCallback, data) {
                    Request.get({
                        url: ApiURLs.accounting.surchargeProfileSurcharges,
                        successCallback: callback,
                        errorCallback: errCallback,
                        data: data
                    });
                },
                getOne: function (id, callback, errCallback, data) {
                    Request.get({
                        url: ApiURLs.accounting.surchargeProfileSurcharges + '/' + id,
                        successCallback: callback,
                        errorCallback: errCallback,
                        data: data
                    });
                },
                create: function (id, callback, errCallback, data) {
                    Request.post({
                        method: 'POST',
                        url: ApiURLs.accounting.surchargeProfileSurcharges + '/' + id,
                        successCallback: callback,
                        errorCallback: errCallback
                    }, data);
                },
                update: function (callback, errCallback, id, data) {
                    Request.post({
                        url: ApiURLs.accounting.surchargeProfileSurcharges + '/' + id,
                        successCallback: callback,
                        errorCallback: errCallback
                    }, data);
                }
            },
            SurchargeProfiles: {
                getAll: function (callback, errCallback, data) {
                    Request.get({
                        url: ApiURLs.accounting.surcharges,
                        successCallback: callback,
                        errorCallback: errCallback,
                        data: data
                    });
                },
                getOne: function (callback, errCallback, id) {
                    Request.get({
                        url: ApiURLs.accounting.surcharges + '/' + id,
                        successCallback: callback,
                        errorCallback: errCallback
                    });
                },
                create: function (callback, errCallback, data) {
                    Request.post({
                        method: 'POST',
                        url: ApiURLs.accounting.surcharges,
                        successCallback: callback,
                        errorCallback: errCallback
                    }, data);
                },
                update: function (callback, errCallback, id, data) {
                    Request.post({
                        url: ApiURLs.accounting.surcharges + '/' + id,
                        successCallback: callback,
                        errorCallback: errCallback
                    }, data);
                }
            },
            CustomerBilling: {
                getAll: function (callback, errCallback, data) {
                    Request.get({
                        url: ApiURLs.accounting.customerBilling,
                        successCallback: callback,
                        errorCallback: errCallback,
                        data: data
                    });
                },
                getShipments: function (id, successCallback, errorCallback, data) {
                    Request.get({
                        url: ApiURLs.accounting.customerBillingShipments.replace(':id', id),
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        data: data
                    });
                },
                getOne: function (callback, errCallback, id) {
                    Request.get({
                        url: ApiURLs.accounting.customerBilling + '/' + id,
                        successCallback: callback,
                        errorCallback: errCallback
                    });
                },
                getAccountPayableDetails(callback, errCallback, id) {
                    Request.get({
                        url: ApiURLs.accounting.accountsPayable + id,
                        successCallback: callback,
                        errorCallback: errCallback
                    });
                },
                downloadFile: function (successCallback, errorCallback, data) {
                    Request.downloadFile({
                        fileName: 'customer-billing-' + data.customerId + '.' + data.fileType.split('/')[1],
                        method: 'GET',
                        url: ApiURLs.accounting.customerBilling + '/' + data.customerId + '/report',
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        fileType: data.fileType,
                        responseType: 'arraybuffer',
                        headers: {
                            Accept: data.fileType
                        }
                    });
                },
                sendEmail: function (callback, errCallback, id, data) {
                    Request.post({
                        method: 'POST',
                        url: ApiURLs.accounting.customerBilling + '/' + id + '/send-report',
                        successCallback: callback,
                        errorCallback: errCallback,
                        data: data
                    });
                },
                markAsPaid: function (callback, errCallback, id) {
                    Request.post({
                        method: 'POST',
                        url: ApiURLs.accounting.markCustomerBillAsPaid.replace(':id', id),
                        successCallback: callback,
                        errorCallback: errCallback
                    });
                },
                closeBilling: function (callback, errCallback, id, fileType = 'pdf', sendMail = false) {
                    Request.post({
                        method: 'POST',
                        url: `${ApiURLs.accounting.closeBilling.replace(':id', id)}?files=${fileType}&sendEmail=${sendMail}`,
                        successCallback: callback,
                        errorCallback: errCallback
                    });
                }
            },
            CustomersBillingSettings: {
                getAll: function (callback, errCallback, data) {
                    Request.get({
                        url: ApiURLs.accounting.customersBillingSettings,
                        successCallback: callback,
                        errorCallback: errCallback,
                        data: data
                    });
                },
                update: function (callback, errCallback, data, carrierConfigurationId) {
                    Request.post({
                        method: 'PUT',
                        url: ApiURLs.accounting.customersBillingSettingsDetails.replace(':carrierConfigurationId', carrierConfigurationId),
                        successCallback: callback,
                        errorCallback: errCallback
                    }, data);
                },
                addNew: function (callback, errCallback, data) {
                    Request.post({
                        method: 'POST',
                        url: ApiURLs.accounting.customersBillingSettings,
                        successCallback: callback,
                        errorCallback: errCallback
                    }, data);
                },
                delete: function (callback, errCallback, carrierConfigurationId) {
                    Request.post({
                        method: 'DELETE',
                        url: ApiURLs.accounting.customersBillingSettingsDetails.replace(':carrierConfigurationId', carrierConfigurationId),
                        successCallback: callback,
                        errorCallback: errCallback
                    });
                }
            },
            AccountsPayable: {
                getAll: function (callback, errCallback, data) {
                    Request.get({
                        url: ApiURLs.accounting.accountsPayable,
                        successCallback: callback,
                        errorCallback: errCallback,
                        data: data
                    });
                },
                getOne: function (callback, errCallback, id) {
                    Request.get({
                        url: ApiURLs.accounting.invoices + '/' + id + '/historical-invoice',
                        successCallback: callback,
                        errorCallback: errCallback
                    });
                },
                approve: function (callback, errCallback, id) {
                    Request.post({
                        method: 'POST',
                        url: ApiURLs.accounting.accountsPayableApprove.replace(':id', id),
                        successCallback: callback,
                        errorCallback: errCallback
                    });
                },
                getPayableInvoiceShipments: function (id, callback, errCallback, data) {
                    Request.get({
                        url: ApiURLs.accounting.historicalBillingShipment.replace(':invoiceId', id),
                        successCallback: callback,
                        errorCallback: errCallback,
                        data: data
                    });
                },
                markAsPaid: function (callback, errCallback, id) {
                    Request.post({
                        method: 'POST',
                        url: ApiURLs.accounting.accountsPayableMarkAsPaid.replace(':id', id),
                        successCallback: callback,
                        errorCallback: errCallback
                    });
                }
            },
            HistoricalBilling: {
                notifyCustomer: function (callback, errorCallback, invoiceId, shipmentId) {
                    Request.post({
                        method: 'POST',
                        url: ApiURLs.accounting.notifyCustomer.replace(':invoiceId', invoiceId).replace(':shipmentId', shipmentId),
                        successCallback: callback,
                        errorCallback: errorCallback
                    });
                },
                issueCreditNote: function (callback, errorCallback, data, id) {
                    Request.post({
                        method: 'POST',
                        url: ApiURLs.accounting.issueCreditNote.replace(':id', id),
                        successCallback: callback,
                        errorCallback: errorCallback
                    }, data);
                }
            },
            IssuedCreditNotes: {
                creditNotes: function (callback, errorCallback, data) {
                    Request.get({
                        url: ApiURLs.accounting.creditNotes,
                        successCallback: callback,
                        errorCallback: errorCallback,
                        data: data
                    });
                },
                newCreditNote: function (callback, errorCallback, shipmentId) {
                    Request.get({
                        url: ApiURLs.accounting.creditNoteNew.replace(':shipmentId', shipmentId),
                        successCallback: callback,
                        errorCallback: errorCallback
                    });
                },
                creditNoteDetails: function (callback, errorCallback, id) {
                    Request.get({
                        url: ApiURLs.accounting.creditNoteDetails.replace(':id', id),
                        successCallback: callback,
                        errorCallback: errorCallback
                    });
                },
                updateCreditNoteDetails: function (callback, errorCallback, id, data) {
                    Request.post({
                        method: 'PUT',
                        url: ApiURLs.accounting.creditNoteDetails.replace(':id', id),
                        successCallback: callback,
                        errorCallback: errorCallback
                    }, data);
                },
                auditLog: function (callback, errorCallback, data) {
                    const invoiceId = data.id;
                    delete data.id;
                    Request.get({
                        url: ApiURLs.accounting.creditNoteAuditLog.replace(':id', invoiceId),
                        successCallback: callback,
                        errorCallback: errorCallback,
                        data: data
                    });
                }
            },
            CustomerAccountingApps: {
                getAvailableAccounting: function (callback, errorCallback, data) {
                    Request.get({
                        url: ApiURLs.accounting.accountApps,
                        successCallback: callback,
                        errorCallback: errorCallback,
                        data: data
                    });
                },
                getAll: function (callback, errorCallback, data) {
                    Request.get({
                        url: ApiURLs.accounting.customerAccountingApps,
                        successCallback: callback,
                        errorCallback: errorCallback,
                        data: data
                    });
                },
                getById: function (callback, errorCallback, id) {
                    Request.get({
                        url: ApiURLs.accounting.customerAccountingAppDetails.replace(':id', id),
                        successCallback: callback,
                        errorCallback: errorCallback,
                    });
                },
                create: function (callback, errorCallback, data) {
                    Request.post({
                        url: ApiURLs.accounting.customerAccountingApps,
                        method: 'POST',
                        successCallback: callback,
                        errorCallback: errorCallback
                    }, data);
                },
                update: function (callback, errorCallback, data, id) {
                    Request.post({
                        url: ApiURLs.accounting.customerAccountingAppDetails.replace(':id', id),
                        method: 'PUT',
                        successCallback: callback,
                        errorCallback: errorCallback
                    }, data);
                },
                authorization: function (callback, errorCallback, id, data) {
                    Request.get({
                        url: ApiURLs.accounting.authorization.replace(':customerAccountingId', id),
                        callback: callback,
                        errorCallback: errorCallback,
                        data: data
                    });
                },
                xeroAuthorization: function (callback, errorCallback, data) {
                    Request.get({
                        url: ApiURLs.accounting.xeroAuthorization,
                        callback: callback,
                        errorCallback: errorCallback,
                        data: data
                    });
                }
            },
            CaseManagement: {
                getAll: function (successCallback, errorCallback, data) {
                    Request.get({
                        url: ApiURLs.accounting.caseManagement,
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        data: data
                    });
                },
                createCase: function (successCallback, errorCallback, data) {
                    Request.post({
                        url: ApiURLs.accounting.caseManagement,
                        method: 'POST',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, data);
                },
                getDetails: function (successCallback, errorCallback, caseGroupId) {
                    Request.get({
                        url: ApiURLs.accounting.caseDetails.replace(':caseGroupId', caseGroupId),
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    })
                },
                updateDetails: function (successCallback, errorCallback, caseGroupId, data) {
                    Request.get({
                        url: ApiURLs.accounting.caseDetails.replace(':caseGroupId', caseGroupId),
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, data);
                }
            }
        };
    }
})();



// WEBPACK FOOTER //
// ./js/services/AccountingService.js